// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"774":"70940079","782":"08cbf17b"}[chunkId] + ".chunk.js";
};